/** Navigation helpers shared by the sign-in screens and the route guards. */

/** Auth screens must never be a post-sign-in destination, or the sign-in screen loops. */
const AUTH_PATHS = ["/login", "/not-invited"];

/**
 * Sanitise a "where was I heading" path.
 * Only same-site absolute paths are allowed, never an auth screen, never an external URL.
 */
export const safeNext = (candidate) => {
  const path = typeof candidate === "string" ? candidate.trim() : "";
  if (!path.startsWith("/") || path.startsWith("//")) return "/";
  if (AUTH_PATHS.some((p) => path === p || path.startsWith(p + "?"))) return "/";
  return path;
};
